// ─────────────────────────────────────────────────────────────
//  ISHA BOUTIQUE — Data
// ─────────────────────────────────────────────────────────────

export const BUSINESS_INFO = {
  name:            'Isha Boutique',
  tagline:         'Traditional South Asian Fashion',
  address:         'Via Cappuccina 15/c',
  city:            '30172 Mestre, Venice, Italy',
  phone:           '+39 392 864 2014',
  phoneRaw:        '+393928642014',
  // WhatsApp — old number (still used for WhatsApp)
  whatsapp:        '+39 329 425 8480',
  whatsappRaw:     '+393294258480',
  facebook:        'https://www.facebook.com/p/Isha-Boutique-100050373225024/',
  messenger:       'https://m.me/100050373225024',
  messengerPageId: '100050373225024',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2796.849476393097!2d12.231673!3d45.479023!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477eb84fcbe1cf47%3A0x6b4f3d5bfc8edc3a!2sVia%20Cappuccina%2C%2015c%2C%2030172%20Venezia%20VE%2C%20Italy!5e0!3m2!1sen!2sit!4v1699900000000!5m2!1sen!2sit',
};

// ─── Collections ─────────────────────────────────────────────
export const COLLECTIONS = [
  {
    id: 'sarees',
    name: 'Sarees',
    description: 'Beautiful traditional and designer sarees for any occasion',
    image: 'https://images.pexels.com/photos/36951187/pexels-photo-36951187/free-photo-of-elegant-indian-woman-in-red-saree-outdoors.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
    alt: 'Traditional saree collection',
    count: '120+ styles',
  },
  {
    id: 'party-dresses',
    name: 'Party Dresses',
    description: 'Authentic festive and party wear from India and Pakistan for all occasions',
    image: 'https://images.pexels.com/videos/35760751/pexels-photo-35760751.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
    alt: 'Authentic Pakistani party dress collection',
    count: '90+ styles',
  },
  {
    id: 'traditional',
    name: 'Traditional Clothing',
    description: 'Everyday comfortable traditional wear including Salwar Kameez and basic kurtas',
    image: 'https://images.pexels.com/photos/6084305/pexels-photo-6084305.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
    alt: 'Traditional Indian clothing and daily wear',
    count: '150+ styles',
  },
  {
    id: 'mens-panjabi',
    name: 'Mens Panjabi & Koti',
    description: 'Vibrant Mens Panjabis paired with elegant Koti vests for religious and cultural events',
    image: 'https://images.pexels.com/photos/27253986/pexels-photo-27253986/free-photo-of-punjabi-boy.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
    alt: 'Mens Panjabi and Koti collection',
    count: '40+ styles',
  },
  {
    id: 'accessories-henna',
    name: 'Bracelets & Henna',
    description: 'Traditional imitation jewelry, colorful bangles, and beautiful Mehndi artistry',
    image: 'https://images.pexels.com/photos/9790789/pexels-photo-9790789.jpeg',
    alt: 'Traditional artificial jewelry and mehndi',
    count: '200+ pieces',
  },
];

// ─── Lookbook / Gallery ───────────────────────────────────────
export const GALLERY_ITEMS = [
  {
    id: 1, name: 'Bridal Lehenga', label: 'New Arrival',
    image: 'https://images.pexels.com/photos/29351977/pexels-photo-29351977/free-photo-of-elegant-bride-in-traditional-indian-attire.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    alt: 'Bridal lehenga', tall: true,
  },
  {
    id: 2, name: 'Silk Saree Drapes', label: 'Bestseller',
    image: 'https://images.pexels.com/photos/19567920/pexels-photo-19567920/free-photo-of-indian-woman-in-a-sari.jpeg',
    alt: 'Silk saree elegantly draped', tall: false,
  },
  {
    id: 3, name: 'Daily Traditional Dress', label: 'Classic',
    image: 'https://images.pexels.com/photos/5289625/pexels-photo-5289625.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
    alt: 'Colorful traditional embroidery', tall: false,
  },
  {
    id: 4, name: 'Saree Collection', label: 'Trending',
    image: 'https://images.pexels.com/photos/28943601/pexels-photo-28943601/free-photo-of-elegant-woman-in-traditional-indian-attire.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    alt: 'Traditional silk saree', tall: true,
  },
  {
    id: 5, name: 'Imitation Bracelets', label: 'Accessories',
    image: 'https://images.pexels.com/photos/7685727/pexels-photo-7685727.jpeg',
    alt: 'Colorful traditional bangles', tall: false,
  },
  {
    id: 6, name: 'Mehndi Art Hands', label: 'Service',
    image: 'https://images.pexels.com/photos/29169303/pexels-photo-29169303/free-photo-of-intricate-mehndi-design-on-bride-s-hand.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
    alt: 'Mehndi painted hands', tall: false,
  },
];

// ─── Testimonials ─────────────────────────────────────────────
export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Priya Sharma',
    location: 'Venice, Italy',
    rating: 5,
    text: 'I found my wedding lehenga here and it was absolutely perfect. The quality of the embroidery is something you simply cannot find anywhere else in Italy. Isha helped me feel like a true bride.',
    avatar: 'PS',
  },
  {
    id: 2,
    name: 'Fatima Al-Hassan',
    location: 'Mestre, Venice',
    rating: 5,
    text: 'The most incredible collection of sarees I have ever seen outside of India. Each piece is carefully curated. I come back every festive season without fail!',
    avatar: 'FA',
  },
  {
    id: 3,
    name: 'Anita Patel',
    location: 'Padova, Italy',
    rating: 5,
    text: 'Such a warm and professional boutique. The Shivali party gowns are absolutely stunning. My daughter wore one to her graduation and everyone asked where it was from.',
    avatar: 'AP',
  },
  {
    id: 4,
    name: 'Sunita Mehta',
    location: 'Milan, Italy',
    rating: 5,
    text: 'I drove from Milan just for this boutique. Worth every kilometre! The collection is updated regularly and the prices are very fair for such premium quality.',
    avatar: 'SM',
  },
  {
    id: 5,
    name: 'Rania Khan',
    location: 'Rome, Italy',
    rating: 5,
    text: 'Finally a place in Italy where South Asian women can find authentic, high-quality fashion. Isha Boutique is a gem. The Banarasi sarees are breathtaking.',
    avatar: 'RK',
  },
];

// ─── Social / Instagram-style photos ─────────────────────────
export const SOCIAL_PHOTOS = [
  '/assets/images/Soc1.jpg',
  'https://images.pexels.com/photos/29351977/pexels-photo-29351977/free-photo-of-elegant-bride-in-traditional-indian-attire.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  '/assets/images/Soc3.jpg',
  '/assets/images/Soc4.jpg',
  '/assets/images/Soc5.jpg',
  '/assets/images/Soc6.jpg',
  '/assets/images/Soc7.jpg',
  '/assets/images/Soc8.jpg',
];
